import React, {useState} from "react"
import {useMessage, useProgress, useLocal} from "../AppContext"
import {hasUrlFlag, URL_FLAG__LIGHTVERSION} from "../Helper/UrlFlag"
import {RoomLabel} from "./RoomLabel";
import {iconArrowToLeft, iconArrowToRight, iconEdit, iconRoomFormSize, iconDoor, iconCouch, iconLamp, iconNoise, iconHome, iconStart, icon3D} from "../Helper/Icons"
import style from "./MenuLeft.css"
import {layoutSidebarLeftWidth} from "../settings";

export const MenuLeft = ({children, label, callbackStatus = null}) => {
    const [hide, setHide] = useState(false)
    const className = hide ? `${style.container} ${style.hide}` : style.container

    const toggleView = () => {
        setHide(hide => {
            if(callbackStatus) callbackStatus(hide)
            return !hide
        })
    }

    const show = () => {
        setHide(false)
        if(callbackStatus) callbackStatus(true)
    }

    return <div className={className} style={{width: `${layoutSidebarLeftWidth + 36}px`}}>
        <Icons onClick={show}/>
        <div className={style.content} style={{width: `${layoutSidebarLeftWidth}px`}}>
            <div style={{width: `${layoutSidebarLeftWidth}px`}}>
                <Header label={label}/>
                <div className={style.children}>
                    {children}
                </div>
            </div>
        </div>
        <Handle hide={hide} onClick={toggleView}/>
    </div>
}

export const MenuLeftLabel = ({label, customStyle = {}}) => <div className={style.label} style={customStyle}>{label}</div>

const Icons = ({onClick}) => {
    const progress = useProgress()
    const local = useLocal()
    const message = useMessage()
    
    const gotoRoom = () => {
        const callback = () => {
            progress.gotoRoom()
        }
        message.showPrompt(local.__("Möchten Sie einen neuen Raumplan erstellen? Die bisher getätigten Einstellungen werden zurückgesetzt."), callback)
    }
    const gotoShape = () => {
        onClick()
        progress.gotoShape()
    }
    const gotoWall = () => {
        onClick()
        progress.gotoWall()
    }
    const gotoFloor = () => {
        onClick()
        progress.gotoFloor()
    }
    const gotoCeiling = () => {
        onClick()
        progress.gotoCeiling()
    }
    const gotoNoise = () => {
        onClick()
        progress.gotoNoise()
    }
    const gotoConditions = () => {
        onClick()
        progress.gotoConditions()
    }
    const gotoSolution = () => {
        onClick()
        progress.gotoSolution()
    }
    
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)

    if (lightversion){
      return <div className={style.icons}>
        <div onClick={gotoRoom}>{iconHome}</div>
        <div onClick={gotoShape} className={progress.isShape() ? style.active : null}>{iconRoomFormSize}</div>
        <div onClick={gotoSolution} className={progress.isSolution() ? style.active : null}>{icon3D}</div>
    </div>

    }
    
    return <div className={style.icons}>
        <div onClick={gotoRoom}>{iconHome}</div>
        <div onClick={gotoShape} className={progress.isShape() ? style.active : null}>{iconRoomFormSize}</div>
        <div onClick={gotoWall} className={progress.isWall() ? style.active : null}>{iconDoor}</div>
        <div onClick={gotoFloor} className={progress.isFloor() ? style.active : null}>{iconCouch}</div>
        <div onClick={gotoCeiling} className={progress.isCeiling() ? style.active : null}>{iconLamp}</div>
        <div onClick={gotoNoise} className={progress.isNoise() ? style.active : null}>{iconNoise}</div>
        <div onClick={gotoConditions} className={progress.isConditions() ? style.active : null}>{iconStart}</div>
        <div onClick={gotoSolution} className={progress.isSolution() ? style.active : null}>{icon3D}</div>
    </div>
}

const Header = ({label}) => {
    const progress = useProgress()
    const local = useLocal()
    const message = useMessage()

    const gotoRoom = () => {
        const callback = () => {
            progress.gotoRoom()
        }
        message.showPrompt(local.__("Möchten Sie einen neuen Raumplan erstellen? Die bisher getätigten Einstellungen werden zurückgesetzt."), callback)
    }

    return <div className={style.header}>
        <div>
            <div><RoomLabel/></div>
            <div onClick={gotoRoom}>{iconEdit}</div>
        </div>
        <div>{label}</div>
    </div>
}

const Handle = ({hide, onClick}) => {
    const handleIcon = hide ? iconArrowToRight : iconArrowToLeft

    return <div className={style.handle} onClick={onClick}>{handleIcon}</div>
}